import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { useEffect, useState } from 'react';

export type CheckEmailMFAProps = {
  email: string;
};

export const CheckEmailMFA: React.FC<CheckEmailMFAProps> = ({ email }) => {
  const [ loading, setLoading ] = useState(true);
  const l10n = useL10n();
  const { classes } = useStyles();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <UpliftThemeProvider>
      <Box flex={1} display="flex" alignItems="center">
        {!loading && (
          <Box textAlign="center">
            <Typography variant="h3" className={classes.checkEmail}>{l10n.auth.checkYourEmail}</Typography>
            <Typography variant="h5" className={classes.magicLink}>{l10n.auth.magicLink(email)}</Typography>
          </Box>
        )}
        {loading && <CircularProgress />}
      </Box>
    </UpliftThemeProvider>
  );
};

const useStyles = makeStyles()((theme) => ({
  checkEmail: {
    color: theme.palette.secondary.dark,
    marginBottom: theme.spacing(2),

    fontSize: '34px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '48px',
    }
  },
  magicLink: {
    fontSize: '24px',
  }
}));
